module.exports = __webpack_public_path__ + "static/media/white-external-link.bee84aaa.svg";